import { useEffect, useState, useCallback } from 'react';

// import axios from 'axios';
import { isBrowser } from '@lucid/utils';

import useSiteMetadata from './use-site-metadata';

const GRECAPTCHA_SRC = 'https://www.google.com/recaptcha/api.js';
// const GRECAPTCHA_VERIFY = 'https://www.google.com/recaptcha/api/siteverify';
type BadgePosition = 'bottomright' | 'bottomleft' | 'inline';

const useRecaptcha = (position: BadgePosition = 'bottomleft') => {
  const [hasRecaptchaLoaded, setHasRecaptchaLoaded] = useState(false);
  const { grecaptchaSiteKey } = useSiteMetadata();
  const setReady = useCallback(() => {
    if (isBrowser()) {
      window.grecaptcha?.ready(() => setHasRecaptchaLoaded(true));
    }
  }, []);

  useEffect(() => {
    let recaptchaScript: HTMLScriptElement | undefined = undefined;

    if (isBrowser()) {
      const currentScript = document.getElementById('recaptcha-script');

      if (currentScript) {
        setReady();
      }

      if (!currentScript) {
        recaptchaScript = document.createElement('script');
        recaptchaScript.src = `${GRECAPTCHA_SRC}?render=${grecaptchaSiteKey}&badge=${position}`;
        recaptchaScript.async = true;
        recaptchaScript.defer = true;
        recaptchaScript.dataset.osano = 'ESSENTIAL';
        recaptchaScript.id = 'recaptcha-script';
        recaptchaScript.addEventListener('load', setReady);
        document.getElementsByTagName('head')[0].appendChild(recaptchaScript);
      }
    }

    return () => {
      if (isBrowser()) {
        recaptchaScript?.removeEventListener('load', setReady);
        const activeScript = document.getElementById('recaptcha-script');
        const activeScriptIframe = document.getElementsByClassName('grecaptcha-badge')[0];
        activeScript?.parentElement?.removeChild(activeScript);
        activeScriptIframe?.parentElement?.removeChild(activeScriptIframe);
      }
    };
  }, [grecaptchaSiteKey, setReady, position]);

  const getToken = async () => {
    try {
      if (isBrowser()) {
        const token = await window.grecaptcha?.execute(grecaptchaSiteKey, {
          action: 'submit',
        });

        return token;
      }
    } catch (error) {
      console.error(`useRecaptcha (getToken): ${error}`);
    }
  };

  // const verifySubmission = async (token?: string) => {
  //   try {
  //     if (!token) return;

  //     const verifySite = await axios({
  //       method: 'POST',
  //       url: GRECAPTCHA_VERIFY,
  //       params: {
  //         // TODO: find best way to get this key from secrets.json
  //         secret: 'secrets.grecaptcha.secret_key',
  //         response: token
  //       }
  //     });

  //     return verifySite;
  //   } catch (error) {
  //     console.error(`useRecaptcha (verifySubmission): ${error}`);
  //   }
  // };

  return { hasRecaptchaLoaded, getToken };
};

export default useRecaptcha;
